import { render, staticRenderFns } from "./json-viewer.vue?vue&type=template&id=65e61e24&scoped=true&"
import script from "./json-viewer.vue?vue&type=script&lang=js&"
export * from "./json-viewer.vue?vue&type=script&lang=js&"
import style0 from "./json-viewer.vue?vue&type=style&index=0&id=65e61e24&scoped=true&lang=css&"
import style1 from "./json-viewer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e61e24",
  null
  
)

export default component.exports